import styled from 'styled-components';

export const PricingModelMainSectionStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-16);
  .pricingModelMainSection {
    &__bidPriceContainer {
      display: flex;
      gap: var(--spacing-16);
      flex: 0 1 260px;

      > * {
        flex: 1 1 0;
        min-width: 0;
      }
    }

    &__expectedMetricValue {
      flex: 0 1 230px;

      .labelUi {
        color: ${props => props.theme.uiColors.textBodyDefault};
        font-family: ${props => props.theme.fontSemiBold};
        font-size: ${props => props.theme.fontSizeS};
        white-space: nowrap;
      }

      .inputAndDescriptionContainer {
        flex: 1 1 auto;
      }
    }

    &__metricSelector {
      flex: 0 1 230px;
    }

    &__infoLabel {
      color: ${props => props.theme.uiColors.textBodyDefault};
      font-family: ${props => props.theme.fontSemiBold};
      font-size: ${props => props.theme.fontSizeS};
      flex: 0 0 fit-content;
      display: flex;
      justify-content: space-around;
    }

    &__modelConfig {
      align-items: flex-start;
      background-color: var(--color-sonata-primary-200, #F2F5FC);
      border-radius: var(--spacing-8);
      display: flex;
      gap: var(--spacing-16);
      min-height: 50px;
      margin-bottom: var(--spacing-8);
      padding: var(--spacing-16);
      flex-wrap: wrap;
    }

    &__otherOptions {
      display: flex;
      flex-basis: 100%;
      flex-direction: row;
      gap: var(--spacing-16);
    }
  }

  .checkboxInsideABox__text {
    color: ${props => props.theme.uiColors.textBodyDefault};
    font-family: ${props => props.theme.fontSemiBold};
    font-size: ${props => props.theme.fontSizeS};
  }
`;
